import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton, TextareaAutosize, TextField } from '@mui/material';
import axios from 'axios';

import api from '../../../utils/axiosInstance';
import { LayoutQuestion } from '../LayoutQuestion';

import styles from '../../Form/Form.module.css';
export default function ComplexQuestion(props) {
  const [uploadError, setUploadError] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileContent, setFileContent] = useState(null);
  const [internalQuestionId] = useState(() => crypto.randomUUID());
  const currentFile = props.selectedFileSelectQuestion?.[internalQuestionId]; // ✅ Usar el archivo del estado global

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    props.setIsUploadingFile(true);

    try {
      const response = await api.post('validateExcelQuestion', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      props.setSelectedFileSelectQuestion((prev) => ({
        ...prev,
        [internalQuestionId]: file,
      }));

      props.setInformation((prev) => ({
        ...prev,
        customOptions: response.data.filas,
        file: file,
      }));

      setUploadSuccess('Archivo válido ✅');
      setUploadError('');
      setFileContent(null);
      
      props.setErrorMessage((prev) => ({
        ...prev,
        selectedFileSelectQuestionError: false,
      }));

      props.setHelperText((prev) => ({
        ...prev,
        selectedFileSelectQuestionHelpertext: '',
      }));
    } catch (err) {
      props.setSelectedFileSelectQuestion((prev) => {
        const updated = { ...prev };
        delete updated[internalQuestionId];
        return updated;
      });
      
      setUploadSuccess('');
      setUploadError(
        err.response?.data?.message || 'Ocurrió un error al validar el archivo'
      );

      const reader = new FileReader();
      reader.onload = function (e) {
        setFileContent(e.target.result);
      };
      reader.readAsText(file);
    } finally {
      props.setIsUploadingFile(false);
    }
  };

  const handleRemoveFile = () => {
    props.setSelectedFileSelectQuestion((prev) => {
      const updated = { ...prev };
      delete updated[internalQuestionId];
      return updated;
    });

    // ✅ Limpiar también information
    props.setInformation((prev) => ({
      ...prev,
      customOptions: Array(2).fill(''),
      file: null,
    }));

    setUploadSuccess('');
    setUploadError('');
    setFileContent(null);
  };

  return (
    <LayoutQuestion {...props}>

      <div className={styles.input} style={{ marginTop: '1rem' }}>
        {!currentFile && (  /* ✅ Usar currentFile en lugar de selectedFile */
          <label htmlFor={`excel-upload-complex-${internalQuestionId}`}> 
            <input
              accept=".xlsx"
              id={`excel-upload-complex-${internalQuestionId}`}  
              type="file"
              hidden
              onChange={handleFileUpload}
            />
            <Button
              variant="outlined"
              component="span"
              color={
                props.errorMessage.selectedFileSelectQuestionError
                  ? 'error'
                  : 'primary'
              }
              sx={{
                borderColor: props.errorMessage.selectedFileSelectQuestionError
                  ? 'red'
                  : undefined,
              }}
            >
              Subir archivo Excel
            </Button>

            {props.errorMessage.selectedFileSelectQuestionError && (
              <p style={{ color: 'red', marginTop: '0.3rem' }}>
                {props.helperText.selectedFileSelectQuestionHelpertext}
              </p>
            )}
          </label>
        )}

        {currentFile && (  /* ✅ Usar currentFile en lugar de selectedFile */
          <div
            style={{
              marginTop: '0.5rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span style={{ marginRight: '1rem', color: '#333' }}>
              Archivo: <strong>{currentFile.name}</strong>
            </span>
            <IconButton size="small" onClick={handleRemoveFile}>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
        {props.isUploadingFile && (
          <p style={{ color: '#888', marginTop: '0.5rem' }}>
            Procesando archivo...
          </p>
        )}
        {uploadError && (
          <p style={{ color: 'red', marginTop: '0.5rem' }}>{uploadError}</p>
        )}
        {uploadSuccess && (
          <p style={{ color: 'green', marginTop: '0.5rem' }}>{uploadSuccess}</p>
        )}
      </div>
    </LayoutQuestion>
  );
}